(() => {
  if (window.gleamCarouselControlsReady) return;
  window.gleamCarouselControlsReady = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gleam-carousel-action]');
    if (!button) return;
    const region = button.closest('[data-gleam-story-reviews]');
    const track = region?.querySelector('[data-gleam-review-track]');
    const card = track?.querySelector('.gleam-review-card');
    if (!track || !card) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
    const direction = button.dataset.gleamCarouselAction === 'next' ? 1 : -1;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: (card.getBoundingClientRect().width + gap) * direction, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
  const gleamCenteredCarousel = () => {
    document.querySelectorAll('[data-gleam-review-track]').forEach(track => {
      if (track.dataset.gleamCenteredCarousel === 'true') return;
      track.dataset.gleamCenteredCarousel = 'true';
      if (window.matchMedia('(max-width: 749px)').matches) return;
      const overflow = track.scrollWidth - track.clientWidth;
      if (overflow > 0) {
        track.scrollLeft = overflow / 2;
      }
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gleamCenteredCarousel, { once: true });
  } else {
    gleamCenteredCarousel();
  }
  document.addEventListener('shopify:section:load', gleamCenteredCarousel);
})();
